import { useState } from 'react';
import { useCallManager } from '../hooks/useCallManager';

export function Dialer() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isCalling, setIsCalling] = useState(false);
  const { makeCall, isRegistered } = useCallManager();

  const handleDigitClick = (digit: string) => {
    setPhoneNumber((prev) => prev + digit);
  };

  const handleBackspace = () => {
    setPhoneNumber((prev) => prev.slice(0, -1));
  };

  const handleCall = async () => {
    if (!phoneNumber || isCalling) return;

    setIsCalling(true);
    try {
      await makeCall(phoneNumber);
    } catch (error) {
      console.error('Call failed:', error);
    } finally {
      setIsCalling(false);
    }
  };

  const digits = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

  return (
    <div className="dialer">
      <div className="dialer-display">
        <input
          type="tel"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="Enter phone number"
          className="dialer-input"
        />
        {phoneNumber && (
          <button
            onClick={handleBackspace}
            className="backspace-button"
            aria-label="Backspace"
          >
            ⌫
          </button>
        )}
      </div>

      <div className="dialer-grid">
        {digits.map((digit) => (
          <button
            key={digit}
            onClick={() => handleDigitClick(digit)}
            className="dialer-button"
          >
            {digit}
          </button>
        ))}
      </div>

      <div className="dialer-actions">
        <button
          onClick={handleCall}
          disabled={!phoneNumber || !isRegistered || isCalling}
          className={`call-button ${!isRegistered ? 'disabled' : ''}`}
        >
          {isCalling ? 'Calling...' : 'Call'}
        </button>
      </div>

      {!isRegistered && (
        <div className="status-message">
          Not registered. Please check your connection.
        </div>
      )}
    </div>
  );
}
